<template>
  <div
    class="headed-container"
    :class="{
      padded: padded,
    }"
  >
    <div
      class="hat"
      :style="{
        backgroundColor: color,
      }"
    >
      <div class="title">
        <slot name="header"></slot>
      </div>
      <div class="content">
        <slot name="header-content"></slot>
      </div>
    </div>

    <div class="inbody">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    color: {
      required: false,
      // default: '$mainGreen',
    },
    padded: {
      default: false,
      type: Boolean,
    },
  }

}
</script>

<style lang="scss" scoped>

.headed-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;

  border-radius: 5px;
  .hat {
    border-radius: 5px 5px 0px 0px;
    min-height: 30px;
    padding: 0 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: $mainGreen;
    .title {
      color: #FFF;
      font-size: 12px;
      font-weight: bold;
      text-transform: uppercase;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .content {
      flex-grow: 1;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
  .inbody {
    background: #fff;
    border-radius: 0px 0px 5px 5px;
    border: 1px solid #E4E5E6;
    border-top-width: 0;
    height: calc(100% - 30px);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  &.padded {
    .inbody {
      padding: 20px 30px;
    }
  }
}

</style>
